import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { GenderPipe } from '@pipes/gender.pipe'
import { DatePipe } from '@pipes/date.pipe'

@NgModule({
  imports: [CommonModule],
  declarations: [GenderPipe, DatePipe],
  exports: [GenderPipe, DatePipe]
})
export class SharedModule {}
